import { render, staticRenderFns } from "./DocumentEmailToMeModal.vue?vue&type=template&id=6ddaeba8&scoped=true&"
import script from "./DocumentEmailToMeModal.vue?vue&type=script&lang=ts&"
export * from "./DocumentEmailToMeModal.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEmailToMeModal.vue?vue&type=style&index=0&id=6ddaeba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddaeba8",
  null
  
)

export default component.exports